import { useQuery } from '@tanstack/react-query';
import { QueryKeys } from '../QueryKeys';
import { getBrandId } from 'src/helpers/getBrandId/getBrandId';
import { getPriceSchemeOverview } from 'src/api/getPriceSchemeOverview/getPriceSchemeOverview';

const staleTime = 5 * 60 * 1000; // 5 minutes

export const usePriceSchemeOverview = (eventId?: string) => {
  return useQuery({
    enabled: !!eventId,
    queryKey: [QueryKeys.priceSchemes, 'overview', getBrandId(), eventId],
    queryFn: () => getPriceSchemeOverview(eventId),
    staleTime,
  });
};
